import { DrawBehavior } from './DrawBehavior';

export class DrawOverlayBehavior extends DrawBehavior {}

export default new DrawOverlayBehavior();
